/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";
// core components
import HeaderImg from "assets/img/IMG_9076.jpg";
import SolSunImg from "assets/img/sol_sun.png";

function SolHeader() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });

  return (
    <>
      <div className='page-header clear-filter' filter-color='blue'>
        <div
          className='page-header-image'
          style={{
            backgroundImage: "url(" + HeaderImg + ")",
          }}
          ref={pageHeader}
        ></div>
        <Container>
          <div className='content-center brand'>
            <img
              alt='Sol Institute Logo'
              className='n-logo'
              src={SolSunImg}
            ></img>
            <h1 className='h1-seo'>The Sol Institute</h1>
            <h3>Lighting The Way For Behavioral Health</h3>
            <h4>Individual, Couples &amp; Family Counseling</h4>
          </div>
        </Container>
      </div>
    </>
  );
}

export default SolHeader;
